export default "__VITE_ASSET__eecc9c98__"